(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mystery-gift-signup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('me-gift-dialog');
  if (!dialog || !dialog.showModal) return;
  const key = 'me-mystery-gift-dismissed';
  const done = 'me-mystery-gift-signed-up';
  const get = k => { try { return localStorage.getItem(k); } catch { return null; } };
  const set = (k,v) => { try { localStorage.setItem(k,v); } catch {} };
  const success = dialog.querySelector('[data-gift-success]') && location.hash === '#MysteryGiftSignup';
  const error = dialog.querySelector('[data-gift-error]') && location.hash === '#MysteryGiftSignup';
  const show = () => { if (!dialog.open) dialog.showModal(); };
  if (success) { set(done,'1'); show(); }
  else if (error) show();
  else if (!window.Shopify?.designMode && !get(done) && Date.now() - Number(get(key) || 0) > 7 * 86400000) {
    setTimeout(show, 8000);
  }
  dialog.querySelector('.me-gift-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if(event.target === dialog) {
    const r = dialog.getBoundingClientRect();
    if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  }});
  dialog.addEventListener('close', () => set(key,String(Date.now())));
})();
  } catch(e) { console.error(e); }
})();

})();
